import { axiosGet } from "../../Helpers";

export const loadCompanyData = async (id, setLoading) => {
  const apiResponse = await axiosGet(`user/getCompanyDetails/${id}`);
  console.log("apiResponse", apiResponse);
  setLoading(false);
  return apiResponse.data;
};
